<div class="Flexbox Flexbox__flex-1 checkbox-filter" *ngFor="let val of filter.config.values;let i =index">
  <dls-check-box (change)="updateSelection($event, val.value)"
    [(ngModel)]="val.isSelected">{{val.value}}</dls-check-box>
  <div class="Flexbox Flexbox__flex-1 Flexbox__just-start ceckboxList_icons">
    <span class="Flexbox__align-self-center" [ngClass]="getIconClass(val.value)"></span>
    <span *ngIf="val.value == 'Somatic'" class="icon__TN-somatic">
      <span class="path1"></span>
      <span class="path2"></span>
    </span>
  </div>
</div>
